// @ts-ignore
import { IconLayer } from "@deck.gl/layers";
import highlightedPin from '../../utils/images/HighlightedStoryPin.svg';
import pin from '../../utils/images/StoryPin.svg';
import { RouteConstants } from "../../constants";

interface StoryLayerProps {
    showStories: boolean;
    stories: any[];
    selectedStory: any;
    pathname: string;
}

export const StoryLayer = ({
    showStories,
    stories,
    selectedStory,
    pathname,
}: StoryLayerProps) => {
    if (!showStories || !stories?.length) return null;

    const isHighlighted = (marker: any) =>
        pathname === RouteConstants.story_details &&
        JSON.stringify(selectedStory?.geometry?.coordinates) === JSON.stringify(marker?.geometry?.coordinates);

    return new IconLayer({
        id: "stories-pins-layer",
        data: stories,
        getPosition: (d: any) => [d.geometry.coordinates[0], d.geometry.coordinates[1]],
        getIcon: (d: any) => {
            const iconUrl = isHighlighted(d) ? highlightedPin : pin;
            return {
                url: iconUrl,
                width: 100,
                height: 100,
                anchorY: 100,
            };
        },
        sizeUnits: "pixels",
        getSize: (d: any) => isHighlighted(d) ? 20: 15,
        pickable: false,
    });
};